import { render, staticRenderFns } from "./OsobaGrupaStatusaForma.vue?vue&type=template&id=dbdf1038&scoped=true&"
import script from "./OsobaGrupaStatusaForma.vue?vue&type=script&lang=js&"
export * from "./OsobaGrupaStatusaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdf1038",
  null
  
)

export default component.exports